import Vue from 'vue'
import Vuex from 'vuex'
import actions from './action'
import mutations from './mutation'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        level: 1,
        isPlaying: false,
        firstClickSquare: null,
        totalCount: 0,
        bombs: [],
        bombCount: 0,
        flagCount: [],
        isShowMask: false,
        gameOver: false,
        gameWin: false,
        timerInterval: null,
        countTime: '00:00:00'
    },
    mutations: mutations,
    actions: actions
})